module.exports = __webpack_public_path__ + "img/logo-znanylekarz-turquoise-rgb.cd899a0e.png";